module.exports = __webpack_public_path__ + "static/media/iar_vehicle_other_selected.96b343e9.svg";